import { uuid } from './regex';

export const IcatuCapRoutes = {
    path: 'cap',
    explain: {
        path: 'explain',
    },
    details: {
        path: `:capId(${uuid})`,
        purchase: {
            path: 'purchase',
            step: {
                path: ':step',
                remainder: {
                    path: ':remainder(.*)?',
                },
            },
        },
        assistances: {
            path: 'assistances',
        },
        reclaim: {
            path: 'reclaim',
        },
    },
};
